<template>
  <div
    class="inline-editor"
  >
    <TiptapWrap
      ref="tiptapWrap"
      v-bind="{ ...$props, ...$attrs }"
      :tiptap-config-override="tiptapConfig"
      v-on="{ 'update:model-value': onInput }"
      @ai-suggest-click="$emit('aiSuggestClick', $event)"
      @add-editor="$emit('addEditor', $event)"
      @blur-editor="$emit('blurEditor', $event)"
      @remove-editor="$emit('removeEditor', $event)"
      @update-selected-json="$emit('updateSelectedJson', $event)"
      @focus-editor="$emit('focusEditor', $event)"
    />
  </div>
</template>

<script>
import { generateHTML } from '@tiptap/html';
import TiptapWrap from '@ui/components/editor/TiptapWrap/TiptapWrap.vue';
import { tiptapWrapProps } from '@ui/components/editor/TiptapWrap/tiptapWrapProps';
import { inlineEditorExtensions } from '@ui/components/editor/TiptapWrap/extensions';

export default {
  name: 'InlineEditor',
  components: { TiptapWrap },

  props: {
    ...tiptapWrapProps,
  },
  emits: [
    'update:modelValue',
    'aiSuggestClick',
    'addEditor',
    'blurEditor',
    'removeEditor',
    'updateSelectedJson',
    'focusEditor',
  ],

  computed: {
    tiptapConfig() {
      return {
        extensions: inlineEditorExtensions({ getTiptapWrap: () => this.$refs.tiptapWrap }),
        ...this.tiptapConfigOverride,
      };
    },
  },
  methods: {
    onInput(event) {
      const rootNode = event.json.content[0] || {};
      const updatedJson = { ...event.json, content: rootNode.content };

      this.$emit('update:modelValue', {
        ...event,
        json: updatedJson,
        html: generateHTML(
          updatedJson,
          inlineEditorExtensions({ getTiptapWrap: () => this.$refs.tiptapWrap }),
        ),
      });
    },
  },
};
</script>

<style scoped lang="less">
.inline-editor  {
  // stops location inline editor from overflowing container
  min-width: 0;

  &:deep(.tiptap-wrap) {
    width: 100%;
  }

  &:deep(.ProseMirror) {
    padding: 0;
    p {
      font-size: 12px;
      line-height: 16px;
      margin-top: 0;
      letter-spacing: 0.5px;
    }
  }
}
</style>
